import { render, staticRenderFns } from "./InvestmentsTable.vue?vue&type=template&id=d4cb00de&"
import script from "./InvestmentsTable.vue?vue&type=script&lang=ts&"
export * from "./InvestmentsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports